import { render, staticRenderFns } from "./Voyage.vue?vue&type=template&id=3cba023e&scoped=true"
import script from "./Voyage.vue?vue&type=script&lang=js"
export * from "./Voyage.vue?vue&type=script&lang=js"
import style0 from "./Voyage.vue?vue&type=style&index=0&id=3cba023e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cba023e",
  null
  
)

export default component.exports